const prefixMap = {
  Auth: "AUTH",
  DeviceInfo: "DEVICE_INFO",
  FeatureFlag: "FEATURE_FLAG",
};

const { Auth, DeviceInfo, FeatureFlag } = prefixMap;

export const SET_ACCESS_TOKEN = `${Auth}/SET_ACCESS_TOKEN`;
export const SET_GUEST_TOKEN = `${Auth}/SET_GUEST_TOKEN`;
export const SET_IS_LOGGED_IN = `${Auth}/SET_IS_LOGGED_IN`;
export const SET_USER_ID = `${Auth}/SET_USER_ID`;
export const SET_USER_TYPE = `${Auth}/SET_USER_TYPE`;
export const SET_CUSTOMER_INFO = `${Auth}/SET_CUSTOMER_INFO`;

export const SET_DEVICE_TYPE = `${DeviceInfo}/SET_DEVICE_TYPE`;
export const SET_MEASUREMENTS = `${DeviceInfo}/SET_MEASUREMENTS`;
export const SET_COOKIE_CONSENT = `${DeviceInfo}/SET_COOKIE_CONSENT`;
export const SET_GA_USER_ID = `${DeviceInfo}/SET_GA_USER_ID`;
export const SET_MOBILE_TYPE = `${DeviceInfo}/SET_MOBILE_TYPE`;

export const SET_FEATURE_FLAGS = `${FeatureFlag}/SET_FEATURE_FLAGS`;

export const SET_IS_LOADING = `${Auth}/LOADING`;
